import { ConfirmDialogOptions } from '@fleet-beat/core';

export const confirmDialogDefaultOptions: ConfirmDialogOptions<boolean> = {
  title: 'Confirmation',
  text: 'Are you sure?',
  hasCloseButton: true,
  closeAction: undefined,
  buttons: [
    {
      caption: 'Cancel',
      action: false,
      color: 'empty',
    },
    {
      caption: 'Yes',
      action: true,
      color: 'success',
    },
  ],
};
